<script>
import BaseConfig from './base.vue'

export default {
  name: 'EventServicesBuyNow',

  extends: BaseConfig,
}
</script>
